
import axios from 'axios';
import API from './config';
import {
    message
} from "antd";

//设置axios基础路径
const request = axios.create({
    baseURL: API,
    timeout: 1000 * 300,
})

// 请求拦截器
request.interceptors.request.use(config => {
    const token = sessionStorage.getItem('token')
    if (token) {
        config.headers['token'] = token
    }
    return config
}, error => {
    return error;
})

// 响应拦截器
request.interceptors.response.use(
    response => {
        if (response.status === 200) {
            const code = Number(response.data.code)
            if (code === 0) {
                return response.data;
            }
            // 后台返回时，没有code值，但有data数据
            if (isNaN(code) && response.data.length > 0) {
                return response.data;
            }

            message.error(response.data.message);
            return Promise.reject(response.data)
        } else {

            message.error(response.data.message);
            return Promise.reject(response.data)
        }
    },
    error => {
        message.error(error.message);
        return Promise.reject(error)
    }
)

/**
 * 配置上传
 * @param {*} url 
 * @param {*} param1 
 * @param {*} fileName 
 * @returns 
 */
request.uploadFile = (url, { file }, fileName = 'file') => {
    let formData = new FormData();
    formData.append(fileName, file)
    return request({
        url,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        transformRequest: data => data,
        method: 'POST',
        data: formData
    })
}

// 最后把封装好的axios导出
export default request
